import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchBrandsData = createAsyncThunk("brands/fetchBrandsData", async ({ page_id, lang = "en" }) => {
  const response = await axios.post(
    "https://milkys.bytesway.io/api/brands",
    {
      page_id,
      lang,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data?.data || {};
});

const BrandsSlice = createSlice({
  name: "brands",
  initialState: {
    section: [],
    brands: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrandsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrandsData.fulfilled, (state, action) => {
        state.loading = false;
        state.section = action.payload.section || [];
        state.brands = action.payload.brands || [];
      })
      .addCase(fetchBrandsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default BrandsSlice.reducer;
